import React from 'react';

import {skipToken} from '@reduxjs/toolkit/query';

import {useAddToFolder} from 'app/documents/api';
import {useFolderByHashid} from 'app/folders/api';
import {CreateItemForm} from 'app/kbs/components/KBEditPage/KBTree/KBTreeArticleItem';
import {gt} from 'app/utils/i18n';

import {AddItemFormBox} from './AddItemFormBox';

import type {BaseDocumentContentType, SearchSerializedType} from 'sweet-types';

type Props = {folderHashid?: string; finalCallback: () => void};
export const AddDocumentToFolder = ({folderHashid, finalCallback}: Props) => {
  const {currentData: selectedFolder} = useFolderByHashid(
    folderHashid != null ? folderHashid : skipToken
  );

  const [addToFolder] = useAddToFolder();
  const doCreateDocument = (
    value: SearchSerializedType<BaseDocumentContentType>
  ) => {
    return addToFolder({
      document_content_type: value.content_type,
      object_id: value.object_id,
      folder: selectedFolder!.url,
    })
      .unwrap()
      .finally(finalCallback);
  };

  return (
    <AddItemFormBox label={gt('Add document')}>
      <CreateItemForm
        onSubmit={doCreateDocument}
        onCancel={finalCallback}
        placeholderText={gt(
          'Select a procedure, process or policy as document...'
        )}
        contentTypes={['procedure', 'policy', 'proceduregroup']}
      />
    </AddItemFormBox>
  );
};
